import React from "react";
import ProfileEditPopup from "../settings/tabs/ProfileEditPopup";
import SubscriptionTierSelection from "../settings/tabs/SubscriptionTierSelection";
import UserManager from "./tabs/organizations/UserManager";
import Integrations from "../pages/Integrations";
// import BillingSettings from "./tabs/billing/BillingSettings"; // Hidden - will be brought back in the future

interface RightPanelProps {
  activeTab: string;
}

const RightPanel: React.FC<RightPanelProps> = ({ activeTab }) => {
  const renderTabContent = () => {
    switch (activeTab) {
      case "profile":
        return <ProfileEditPopup />;
      case "subscription":
        return <SubscriptionTierSelection />;
      case "members":
        return <UserManager />;
      // case "billing":
      //   return <BillingSettings />; // Hidden - will be brought back in the future
      case "integrations":
        return <Integrations />;
      default:
        return null;
    }
  };

  return (
    <div className="flex-1 bg-background-default dark:bg-background-dark overflow-hidden flex flex-col">
      <div className="flex-1 overflow-y-auto scrollbar-hide">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default RightPanel;
